export const state = {
  labours: [],
  labour_items: [],
  labour_item: [
    {
      truck_id: "",
      labour_description: "",
      labour_measurement: "",
      qty: "",
      unit_price: "",
      total_price: "",
      remark: ""
    }
  ]
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/labours/state.js